import React from 'react';
interface PaxStatementNotesProps {
  externalNotes?: string;
  termsAndConditions?: string;
  termsUrl?: string;
  showDeclaration?: boolean;
  bookingStaffName?: string;
}
export function PaxStatementNotes({
  externalNotes,
  termsAndConditions,
  termsUrl,
  showDeclaration = true,
  bookingStaffName
}: PaxStatementNotesProps) {
  return <div className="mb-6 space-y-5" data-id="element-719">
      {/* External Notes */}
      {externalNotes && <div data-id="element-720">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-2" data-id="element-721">
            External Notes
          </h3>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-722">
            <p className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-723">
              {externalNotes}
            </p>
          </div>
        </div>}

      {/* Terms & Conditions */}
      {termsAndConditions && <div data-id="element-724">
          <div className="flex items-center justify-between mb-2" data-id="element-725">
            <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide" data-id="element-726">
              Terms & Conditions
            </h3>
            {termsUrl && <a href={termsUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:underline" data-id="element-727">
                See full T&C
              </a>}
          </div>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-728">
            <p className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-729">
              {termsAndConditions}
            </p>
          </div>
        </div>}

      {/* Declaration - Only show if enabled */}
      {showDeclaration && <div data-id="element-730">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-2" data-id="element-731">
            Declaration
          </h3>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-732">
            <p className="text-xs text-neutral-700 leading-relaxed mb-3" data-id="element-733">
              I/We have been advised to purchase travel insurance against
              insolvency of the travel agent. I/We:
            </p>
            <div className="space-y-2.5 mb-5 text-xs text-neutral-700" data-id="element-734">
              <label className="flex items-center gap-3" data-id="element-735">
                <input type="checkbox" className="w-4 h-4 rounded border-neutral-300" data-id="element-736" />
                <span data-id="element-737">Have purchased travel insurance through the agent</span>
              </label>
              <label className="flex items-center gap-3" data-id="element-738">
                <input type="checkbox" className="w-4 h-4 rounded border-neutral-300" data-id="element-739" />
                <span data-id="element-740">Will purchase travel insurance myself</span>
              </label>
              <label className="flex items-center gap-3" data-id="element-741">
                <input type="checkbox" className="w-4 h-4 rounded border-neutral-300" data-id="element-742" />
                <span data-id="element-743">Do not wish to be insured</span>
              </label>
            </div>

            {/* Signature Row - Two Column Layout */}
            <div className="grid grid-cols-2 gap-8 mt-6 pt-5 border-t border-neutral-200" data-id="element-744">
              {/* Left Column - Passenger (3 lines to fill) */}
              <div className="space-y-3" data-id="element-745">
                <div className="flex items-center gap-4" data-id="element-746">
                  <span className="text-xs text-neutral-600 w-20" data-id="element-747">
                    Signature:
                  </span>
                  <div className="flex-1 border-b-2 border-neutral-300 h-10" data-id="element-748"></div>
                </div>
                <div className="flex items-center gap-4" data-id="element-749">
                  <span className="text-xs text-neutral-600 w-20" data-id="element-750">Name:</span>
                  <div className="flex-1 border-b-2 border-neutral-300 h-10" data-id="element-751"></div>
                </div>
                <div className="flex items-center gap-4" data-id="element-752">
                  <span className="text-xs text-neutral-600 w-20" data-id="element-753">Date:</span>
                  <div className="flex-1 border-b-2 border-neutral-300 h-10" data-id="element-754"></div>
                </div>
              </div>

              {/* Right Column - Sales Staff (display only) */}
              <div data-id="element-755">
                <div className="flex items-center justify-between mb-2" data-id="element-756">
                  <span className="text-xs text-neutral-600" data-id="element-757">Sales Staff:</span>
                  <span className="text-xs font-semibold text-neutral-900" data-id="element-758">
                    {bookingStaffName || 'N/A'}
                  </span>
                </div>
                <div className="border-b-2 border-neutral-300 h-10" data-id="element-759"></div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}